import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .BonusesTable {
    .ReactDataTable__wrapper {
      @include respond-to(xl) {
        overflow-x: auto;
      }

      .ReactDataTable th,
      .ReactDataTable td {
        padding: 3px;
      }

      .ReactDataTable__tbody-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .ReactDataTable {
        tr {
          grid-template-columns:
            minmax(70px, 0.8fr) /* id */
            minmax(100px, 1fr) /* bonusType */
            minmax(100px, 1fr) /* account */
            minmax(140px, 1.5fr) /* receivingDate */
            minmax(140px, 1.5fr) /* validUntil */
            minmax(110px, 1fr) /* value */
            minmax(60px, 1fr) /* fulfillmentOfTerms */
            minmax(60px, 1fr) /* termsOfReceipt */
            minmax(120px, 1.5fr) /* status */
            minmax(110px, 1fr); /* actions */
        }

        .ReactDataTable__tbody-row {
          height: 70px;
          font-size: 13px;
          padding: 0 10px;
          align-items: center;
        }

        /* BonusType (col 2) */
        .ReactDataTable__tbody-cell:nth-child(2) .BonusesTable__types {
          display: flex;
          flex-direction: column;
        }

        /* Value (col 6) */
        .ReactDataTable__tbody-cell:nth-child(6) .MoneyCell__inner span {
          font-size: 13px !important;
        }

        /* Status (col 9) */
        .ReactDataTable__tbody-cell:nth-child(9) .StatusCell {
          font-size: 11px !important;
        }

        /* Actions (col 10) */
        .ReactDataTable__tbody-cell:last-child button span {
          font-size: 13px !important;
          line-height: normal;
        }
      }
    }

    /* --- Responsive layout --- */
    .ResponsiveTable__thead {
      min-width: 320px !important;

      span {
        text-align: center;
        padding: 5px 0;

        &:nth-child(1) {
          flex: 8; /* bonusType */
        }

        &:nth-child(2) {
          flex: 6; /* value */
        }

        &:nth-child(3) {
          flex: 6; /* status */
        }
      }
    }

    .ResponsiveTable__row {
      .ResponsiveTable__row-item {
        display: flex;
        align-items: center;

        &:nth-child(1) {
          flex: 8; /* bonusType */
          .BonusesTable__types {
            display: flex;
            flex-direction: column;
          }
        }

        &:nth-child(2) {
          flex: 6; /* value */
          font-size: rem(13px);
        }

        &:nth-child(3) {
          flex: 6; /* status */
          font-size: rem(13px);
        }
      }
    }

    .BonusesTable__cancel-error {
      max-width: 360px;
      margin-top: rem(10px);
    }
  }

  .BonusModal {
    :global(&__btns) {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .BonusesTable {
      &__until {
        &.active,
        &.completed {
          color: ${colors.success.hex};
        }

        &.expired {
          color: ${colors.error.hex};
        }

        &.rejected {
          color: ${colors.gray.hex};
        }
      }

      .defaultType {
        color: ${colors.gray.hex};
      }
    }

    .BonusesTable__cancel-error {
      color: ${colors.error.hex};
    }
  `;
};

export { staticStyles, getDynamicStyles };
